import { gql } from "@apollo/client";

export const VENDOR_COMPANY_COUNT_QUERY = gql`
  query vendorCompanyCountQuery(
    $vendorId: Int!
    $localizeInstalls: Boolean!
    $isDp: Boolean
    $isDu: Boolean
    $isGhq: Boolean
    $isGp: Boolean
    $isGu: Boolean
  ) {
    opportunityGeneratorSearch(
      filters: {
        vendors: [{ ids: [$vendorId], inclusionMethod: ANY_PRESENT }]
        isDp: $isDp
        isDu: $isDu
        isGhq: $isGhq
        isGp: $isGp
        isGu: $isGu
      }
      localizeInstalls: $localizeInstalls
    ) {
      data {
        name
        hgId
        url
        countryName
        revenueRange {
          min
          max
          band
        }
      }
      count
    }
  }
`;
